/*
 * @Author: 李明明
 * @Date: 2022-07-28 14:08:34
 * @LastEditTime: 2023-04-06 16:10:55
 * @LastEditors: 李明明
 * @Description: 
 * @FilePath: /ykt-micro-main/src/utils/cookie.js
 * 代码版权方：'政府采购信息网'
 */
import Store from "../store";

// 设置cookie
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+d.toUTCString() + ";domain=.caigou2003.com";
  document.cookie = cname + "=" + cvalue + "; " + expires;
}

/**
 * 获取cookie
 * @param name
 * @returns {string}
 */
export function getCookie(name) {
  const arr = document.cookie.split("; ");
  for (let i = 0; i < arr.length; i++) {
    const arr2 = arr[i].split("=");
    if (arr2[0] == name) {
      return  unescape(arr2[1]).replace(/%/g, '%25')
    }
  }
  return ""
}

// 删除cookie
export function clearCookie(name) {
  Store.state.userInfo = {}
  setCookie(name, "", -1);
}
